module.exports = __webpack_public_path__ + "img/jbt1010_yu_imb35_90s_2.prt.a947f2d3.jpg";